module.exports = __webpack_public_path__ + "assets/img/44e4-gm.svg";